/**
 * Spec 055: converte os pontos da VIAGEM (classe tarifária da busca) para os pontos da POLTRONA
 * escolhida, proporcional ao preço — na Distribusion cada andar tem classe e preço próprios, e o térreo
 * costuma ser o mais caro. Serve só ao aviso de saldo ANTES de reservar; o valor que vale é o do carrinho,
 * depois da reserva. Sem preço da poltrona (MuviFlex, provedor sem classe por andar) devolve os pontos da
 * viagem, como era antes.
 */
export function scalePointsToSeat(points, seatPrice, tripPrice) {
	const tripValue = tripPrice && (tripPrice.valueToShow || tripPrice.value)

	if (!points || !seatPrice || !tripValue) return points || 0

	const ratio = seatPrice / tripValue

	if (!isFinite(ratio) || ratio <= 0) return points

	return Math.ceil(points * ratio)
}
